export const SLIDER_DATA = [
  {
    url: "https://cdn.dotpe.in/longtail/dlp/7612844/5mN6AlaO.png",
    text: "CRM, Abandoned Cart & Lead Generation",
  },
  {
    url: "https://cdn.dotpe.in/longtail/dlp/7612844/E99Ln0Yp.png",
    text: "Run Google Ads, Convert with WhatsApp Campaigns",
  },
  {
    url: "https://cdn.dotpe.in/longtail/dlp/7612844/toqx2i6N.png",
    text: "Collect payment online, With lowest transaction charges.",
  },
  {
    url: "https://cdn.dotpe.in/longtail/dlp/7612844/2DWkNgir.png",
    text: "National delivery, within and across cities.",
  },
];
export const MIN_PERCENTAGE_CHECK = 5;
export const SOURCE_DS_LANDING = "ds_landing_page";

export const DOMAIN_TAGS = {
  EXACT_MATCH: "Exact match",
  AVAILABLE: "This domain is available",
  ALTERNATIVE: "Next best alternative",
};

export const AppStoreImage = "https://cdn.dotpe.in/longtail/dlp/7612844/5v1L4eYq.png";
export const GooglePlayStoreImage = "https://cdn.dotpe.in/longtail/dlp/7612844/6FoJb7ES.png";
export const DSNameLogoInMobile = "https://cdn.dotpe.in/longtail/dlp/7612844/vNmmT8kT.png";
export const DSRatings = "https://cdn.dotpe.in/longtail/dlp/7612844/IqELKqXZ.png";

export const SELL_SERVICE_WEBSITE = "https://cdn.dotpe.in/longtail/dlp/7612844/de3mhDb8.png";
export const SELL_ECOMMERCE_WEBSITE = "https://cdn.dotpe.in/longtail/dlp/7612844/gvjyZPZD.png";
export const DLP_HERO_SECTION_IMAGE = "https://cdn.dotpe.in/longtail/dlp/7612844/uWAXPUci.png";
export const HIDE_DOMAIN_PURCHASE_SUCCESSFUL_TEXT = "hideDomainPurchaseSuccessfulText";
export const THEME_UPSELL_POPUP_DISPLAYED_TEXT = "themeUpsellPopupShown";
export const DLP_BANNER_UPSELL_FEATURE_TYPE = {
  THEME: "theme",
};
